module.exports = __webpack_public_path__ + "img/71.cfd54446.jpg";